import styled from 'styled-components';

const RadioWrapper = styled.span`
  margin: 8px 8px 8px 0;
`;

export default RadioWrapper;
